var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.saveForm()}}},[_c('div',{staticClass:"modal-card",staticStyle:{"width":"auto"}})])}
var staticRenderFns = []

export { render, staticRenderFns }